type LiveEnv = "local" | "staging" | "production";

export const LIVE_ENV = import.meta.env.VITE_LIVE_ENV as LiveEnv;
